import { render } from "./SideToolBar.vue?vue&type=template&id=5c1adfac&scoped=true&ts=true"
import script from "./SideToolBar.vue?vue&type=script&lang=ts"
export * from "./SideToolBar.vue?vue&type=script&lang=ts"

import "./SideToolBar.vue?vue&type=style&index=0&id=5c1adfac&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1adfac"]])

export default __exports__